import styled from 'styled-components';

import { Page } from '../../layout/components/Page';

export const PageContent = styled(Page.ContentFluid)`
  justify-content: center;
`;
